module.exports = __webpack_public_path__ + "img/0527-g.f849c6ec.svg";